import { FC, HTMLAttributes } from 'react';
import styled, { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FooterSG } from '../FooterSG';
import { FooterTitleSG } from '../FooterTitleSG';
import { GamePart, GamePartProps, GamePartDot } from '../GamePart';
import { InfoButton } from '../InfoButton';
import { Winners as Winner } from '../CongratulationsPanel';

type PartWinnerPreviewSGProps = HTMLAttributes<HTMLDivElement> &
    GamePartProps & {
        winner: Winner;
        handleClick: () => void;
    };

const PartWinnerPreviewSGContainer = styled(FooterSG)`
    justify-content: space-around;
    align-items: center;
    padding-left: 8.375rem;
`;

const StarImage = styled.img`
    position: absolute;
    left: 0.688rem;
    top: -1rem;
    width: 7.438rem;
    height: 5.813rem;
`;

const PartWinnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`;

const GamePartWrapper = styled(GamePart)`
    ${GamePartDot} {
        width: 0.938rem;
        height: 0.938rem;
    }
`;

const NameAmountContainer = styled.div`
    flex: 1;
    font-family: Signika-Bold;
    font-size: 2.063rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    margin: 0.75rem 1rem 0;
    color: ${({ theme }) => theme.color};
`;

const InfoButtonWrapper = styled(InfoButton)`
    width: 4.375rem;
    height: 4.375rem;
`;

export const PartWinnerPreviewSGPortrait: FC<PartWinnerPreviewSGProps> = ({
    gameParts,
    currentPart,
    fireBall,
    winner,
    handleClick,
    ...props
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { starImage3 } = theme.images;
    return (
        <PartWinnerPreviewSGContainer showFooter={true} {...props}>
            <StarImage src={starImage3} alt="Star Image" />
            <PartWinnerContainer>
                <GamePartWrapper
                    gameParts={gameParts}
                    currentPart={currentPart}
                    fireBall={fireBall}
                />
                <FooterTitleSG text={t('Bingo Winner!')} />
            </PartWinnerContainer>
            <NameAmountContainer>
                {winner?.name} {winner?.amount}
            </NameAmountContainer>
            <InfoButtonWrapper handleClick={handleClick} />
        </PartWinnerPreviewSGContainer>
    );
};
